// extracted by mini-css-extract-plugin
module.exports = {"footer":"_6c97079b1b--footer--hwbgM","button-wrapper":"_6c97079b1b--button-wrapper--B70Pe"};